import React, { useEffect } from "react";
import { useNavigate, Routes, Route } from "react-router-dom";
import "./App.scss";
import routes from "./routes";
import nucleusxp from "nucleusxp";

const App = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!nucleusxp.isAuthenticated()) {
      navigate(routes.login.path);
    }
  }, [navigate]);

  return (
    <div className="container">
      <Routes>
        {Object.entries(routes).map(([key, route]) => (
          <Route key={key} path={route.path} element={route.element} />
        ))}
      </Routes>
    </div>
  );
};

export default App;
